
/**
 * 环节类型
 */
export const TABLEYAPE_DYNAMIC ='dynamic'
export const TABLEYAPE_STATIC ='static'

/**
 * 环节在路由上的呈现类型
 */
export const STEP_ROUTER_KEY_MAP = {
  ANNULAR_ASSESS: 'annularAssess',
  TEAM_ASSESS: 'teamAssess',
  TEAM_VIEW: 'teamView',
  CONFRIM_INVITE: 'confrimInvite',
  RESULT_REVIEW: 'resultReview'
}